'use strict';

/* globals config */

require([config.relative_path + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js'], function (Vue) {
	Vue.component('sound-answer-edit', {
		props: ['answer', 'initData'],
		data: function () {
			return {
				label: this.initData.translations.uploadSound,
				icon: 'fa fa-music',
			};
		},
		methods: {
			onUploadSuccess: function (sound) {
				this.saveFilePermissions(sound.url);
				this.answer.content = sound.url;
			},
		},
		template:
		'<div>' +
			'<audio v-if="answer.content" controls><source :src="answer.content"></audio>' +
            '<upload-component :label="label" :icon="icon" :onUploadSuccess="onUploadSuccess"></upload-component>' +
		'</div>',
	});
});
